// vm-pagination.js
import { LitElement, html } from 'lit';
import Styles from './vm-list-pagination.scss';

export default class VmListPagination extends LitElement {
    static styles = Styles;
    static properties = {
        totalPages: { type: Number },
        currentPage: { type: Number },
    };

    constructor() {
        super();
        this.currentPage = 1;
    }

    emitNavigate(pageIndex) {
        this.dispatchEvent(
            new CustomEvent('vm-pagination-click', {
                detail: { pageIndex },
                bubbles: true,
                composed: true,
            }),
        );
    }

    renderPageButtons() {
        return Array.from({ length: this.totalPages }, (_, index) => {
            const i = index + 1;

            return html`
                <button
                    class="
                        vm-button vm-button--sm vm-button--tertiary vm-button--pagination
                        ${this.currentPage === i ? 'vm-button--active' : ''}
                    "
                    data-page-index="${i}"
                    type="button"
                    @click=${() => this.emitNavigate(i)}
                >
                    ${i}
                </button>
            `;
        });
    }

    render() {
        return html`
            <div class="pagination js_pagination" part="pagination">
                <button
                    class="vm-button vm-button--sm vm-button--tertiary vm-button--pagination js_paginationPrev"
                    ?disabled=${this.currentPage === 1}
                    data-page-index="${this.currentPage - 1}"
                    @click=${() => this.emitNavigate(this.currentPage - 1)}
                >
                    <span class="icon icon-chevron-left"></span>
                </button>
                <div class="pagination__pages">${this.renderPageButtons()}</div>
                <button
                    class="vm-button vm-button--sm vm-button--tertiary vm-button--pagination js_paginationNext"
                    ?disabled=${this.currentPage === this.totalPages}
                    data-page-index="${this.currentPage + 1}"
                    @click=${() => this.emitNavigate(this.currentPage + 1)}
                >
                    <span class="icon icon-chevron-right"></span>
                </button>
            </div>
        `;
    }
}
